import React from 'react';
import Modal3Opciones from './Modal3Opciones';
import EditarTurnoModal from './EditarTurnoModal';
import ModalConfirmacion from './ModalConfirmacion';
import ModalNuevoPaciente from './ModalNuevoPaciente';

// Agrupa los modales que puede disparar useAccionesTurno (edición simple,
// edición en serie, cancelación en serie/simple, renombrar). Se renderiza
// una sola vez tanto en Calendario.jsx como en PendientesDelDia.jsx para no
// duplicar el flujo de edición/cancelación/renombrado de turnos.
function TurnoModals({ acciones }) {
  const {
    editModal, editFecha, setEditFecha, editHora, setEditHora, editDuracion, setEditDuracion,
    editNotas, setEditNotas, editTitulo, setEditTitulo, editGuardando, guardarEdit, cerrarEdicion,
    editPendiente, editarSoloEste, editarEstoYSiguientes, editarTodaLaSerie, cerrarEditPendiente,
    cancelPendiente, cancelarSoloEste, cancelarEstoYSiguientes, cancelarTodaLaSerie, cerrarCancelPendiente,
    confirmEliminar, confirmarEliminarCita, cerrarConfirmEliminar,
    iniciarRenombrar, renombrarPacienteForm, renombrarPacienteConfirmar, renombrarGuardando, renombrarError,
    cerrarRenombrarPaciente, confirmarRenombrarPaso1, volverARenombrarPaso1, confirmarRenombrarPaso2,
  } = acciones;

  // El lápiz de EditarTurnoModal cierra ese modal antes de abrir el flujo de
  // renombrar paciente -- dos formularios activos al mismo tiempo (fecha/
  // hora/duración/notas por un lado, nombre/apellido por otro) sería
  // confuso sobre cuál "Guardar" aplica a qué.
  const onRenombrarDesdeEdicion = (turno) => {
    cerrarEdicion();
    iniciarRenombrar(turno);
  };

  return (
    <>
      {editModal && (
        <EditarTurnoModal
          turno={editModal}
          fecha={editFecha} setFecha={setEditFecha}
          hora={editHora} setHora={setEditHora}
          duracion={editDuracion} setDuracion={setEditDuracion}
          notas={editNotas} setNotas={setEditNotas}
          titulo={editTitulo} setTitulo={setEditTitulo}
          guardando={editGuardando}
          onGuardar={guardarEdit}
          onCerrar={cerrarEdicion}
          onRenombrarPaciente={onRenombrarDesdeEdicion}
        />
      )}

      {editPendiente && (
        <Modal3Opciones
          titulo="Aplicar cambios"
          mensaje={<>¿A qué turnos querés aplicar el cambio de <strong>{editPendiente.nombrePaciente}</strong>?</>}
          cantFuturos={editPendiente.futuros.length}
          cantTodos={editPendiente.todos.length}
          onCancelar={cerrarEditPendiente}
          onSoloEste={editarSoloEste}
          onEstoYSiguientes={editarEstoYSiguientes}
          onTodaLaSerie={editarTodaLaSerie}
        />
      )}

      {cancelPendiente && (
        <Modal3Opciones
          titulo="Cancelar turno"
          mensaje={<>¿Qué querés cancelar de los turnos de <strong>{cancelPendiente.nombrePaciente}</strong>?</>}
          cantFuturos={cancelPendiente.futuros.length}
          cantTodos={cancelPendiente.todos.length}
          onCancelar={cerrarCancelPendiente}
          onSoloEste={cancelarSoloEste}
          onEstoYSiguientes={cancelarEstoYSiguientes}
          onTodaLaSerie={cancelarTodaLaSerie}
          textoCancelar="Volver"
          peligro
        />
      )}

      {confirmEliminar && (
        <ModalConfirmacion
          mensaje="¿Eliminar este turno o evento del calendario?"
          textoConfirmar="Eliminar"
          onConfirmar={confirmarEliminarCita}
          onCancelar={cerrarConfirmEliminar}
        />
      )}

      {/* Renombrar paciente — paso 1: form nombre/apellido (mismo componente
          que "Agregar paciente nuevo", con copy propio vía props). */}
      {renombrarPacienteForm && !renombrarPacienteConfirmar && (
        <ModalNuevoPaciente
          titulo="Renombrar paciente"
          nombreInicial={renombrarPacienteForm.nombreActual}
          apellidoInicial={renombrarPacienteForm.apellidoActual}
          textoAlerta="Este cambio actualiza el nombre real del paciente — se va a reflejar en todos sus turnos y en su ficha completa, no es una etiqueta de este turno puntual."
          textoBoton="Continuar"
          onConfirmar={confirmarRenombrarPaso1}
          onCerrar={cerrarRenombrarPaciente}
        />
      )}

      {/* Renombrar paciente — paso 2: confirmación explícita del alcance
          (mismo patrón que "Reactivar paciente"/"Marcar inactivo"). */}
      {renombrarPacienteConfirmar && (
        <ModalConfirmacion
          mensaje={
            <>¿Renombrar a <strong>{`${renombrarPacienteConfirmar.nombreActual} ${renombrarPacienteConfirmar.apellidoActual}`.trim() || 'este paciente'}</strong> como <strong>{`${renombrarPacienteConfirmar.nombre} ${renombrarPacienteConfirmar.apellido}`.trim()}</strong>?</>
          }
          textoAlerta="Afecta la ficha completa del paciente y todos sus turnos — no solo este."
          textoConfirmar={renombrarGuardando ? 'Guardando...' : 'Renombrar'}
          onConfirmar={confirmarRenombrarPaso2}
          onCancelar={volverARenombrarPaso1}
          errorExterno={renombrarError}
        />
      )}
    </>
  );
}

export default TurnoModals;
